import { ModalActionTypes } from "../constants";

interface ShowModalAction {
  type: "SHOW_MODAL",
  payload: {
    show: boolean,
  },
}

export const showModal = (): ShowModalAction => {
  return {
    type: ModalActionTypes.SHOW_MODAL,
    payload: { show: true },
  };
};

interface HideModalAction {
  type: "HIDE_MODAL",
}

export const hideModal = (): HideModalAction => {
  return {
    type: ModalActionTypes.HIDE_MODAL,
  };
};

export type Action = ShowModalAction | HideModalAction;
